import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-updated-fees';

export default function Example() {
  return (
    <>
      <Head>
        <title>eBay's 2022 Seller Price Increases and Fees</title>
        <meta
          name='description'
          content='From Final Value Fees, Standard Selling, Monthly Subscription to other important calculation methods, here is what you should expect starting March 1, 2022.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-updated-fees' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-updated-fees' />
        <meta property='og:title' content="eBay's 2022 Seller Price Increases and Fees" />
        <meta
          property='og:description'
          content='From Final Value Fees, Standard Selling, Monthly Subscription to other important calculation methods, here is what you should expect starting March 1, 2022.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
